import { useSelector } from 'react-redux';
import { useSelectors } from '@exodus/headless-react';
const useExchangeAvailability = () => {
    const selectors = useSelectors();
    return useSelector(selectors.exchange.swapAvailability);
};
export const useIsExchangeUnavailable = () => {
    const selectors = useSelectors();
    const availability = useSelector(selectors.exchange.swapAvailability);
    return availability ? !availability.isAvailable : false;
};
export default useExchangeAvailability;
